<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      龙东站<br>
站点介绍<br>
龙东站位于龙岗区深汕公路与爱南路交叉口处，车站主体沿深汕公路呈东西走向布置，东接宝龙同乐站，西接新塘围站。车站色彩基调以白色调为主，以“客居”为主题，运用富有科技感的生态绿色打造具有未来感的空间。车站为地下二层结构，地下一层为站厅层，地下二层为站台层，站台形式为岛式站台。车站设置有6个出入口，临近育贤学校，周边为成熟配套生活区。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:13	23:23	16号线	5分32秒	6分43秒<br>
田心	06:10	23:26	16号线	5分32秒	6分43秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:23	23:23	16号线	5分50秒	6分钟-9分钟<br>
田心	06:16	23:26	16号线	5分50秒	6分钟-9分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:23	00:23	16号线	5分50秒	6分钟-9分钟<br>
田心	06:16	00:26	16号线	5分50秒	6分钟-9分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
赤石岗村（西）、富业商品批发城、鸿景春天、骏泰金夕府、义乌小商品批发城、丽枫酒店、育贤小学、大浦二村、爱维艾夫妇科医院、龙岗区明星学校、银龙工业科技园<br><br>
B出入口:<br>
同乐高速路口、新大坑小区<br><br>
C出入口:<br>
中骏四季阳光小区、嘉誉业物流产业园、赤石岗村（东）、同心实验学校<br><br>
D出入口:<br>
中信龙盛广场、恒御嘉城<br><br>
公交换乘信息<br><br>
A1出入口:<br>
公交站名： 石湖龙居民小组站<br>
M195、802、818、E34、M136、M432、M266、M277、M279、M296、M304、M320、M359、M361、M431、M49<br><br>
A1出入口:<br>
公交站名： A2出入口石湖龙居民小组站<br>
M195、802、818、E34、M136、M266、M277、M279、M296、M359、M361、M431、M497<br><br>
B出入口:<br>
公交站名： 同乐汽车站<br>
M277<br><br>
C出入口:<br>
公交站名： 同乐汽车站<br>
M277<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shiliuhaoxian",
            title: "16号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>